import React, { useContext } from "react";
import SelectionItem from "../../SelectionItem";
import ImgBugelBase from "./images/bugelBase.png";
import ImgPlasticBase from "./images/plasticBase.png";
import "./index.scss";
import { StepContext } from "../../StepContext";
import { useTranslation } from "../../../i18n";

const RemovableProstheticsSelectSide = ({
  selectStep
}) => {
  const {
    _t
  } = useTranslation();
  const {
    toggleBottomBarInfo
  } = useContext(StepContext);
  const types = [{
    key: "bugelBase",
    img: ImgBugelBase,
    name: _t("Металлический базис"),
    description: _t("Металлический базис считается более долговечным и удобным для использования...")
  }, {
    key: "plasticBase",
    img: ImgPlasticBase,
    name: _t("Пластиковый базис"),
    description: _t("Пластиковый базис протеза более эстетичен и может изготавливаться из акрила или нейлона...")
  }];

  function setStep(key) {
    selectStep(key);
  }

  function openBottomBar(type) {
    toggleBottomBarInfo(true, type);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "removableProstheticsSelect"
  }, /*#__PURE__*/React.createElement("div", {
    className: "removableProstheticsSelect-list"
  }, types.map(el => /*#__PURE__*/React.createElement(SelectionItem, {
    key: el.key,
    itemKey: el.key,
    isSelected: false,
    select: () => {
      setStep(el.key);
    },
    preview: el.img,
    outerTitle: el.name,
    outerDescription: el.description,
    aboutClick: () => openBottomBar(el.key)
  }))));
};

export default RemovableProstheticsSelectSide;